import { render, staticRenderFns } from "./_lesson_section.vue?vue&type=template&id=32b63e82"
import script from "./_lesson_section.vue?vue&type=script&lang=js"
export * from "./_lesson_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports